import { mapGetters, mapMutations } from 'vuex';
import Forms from '../../utils/forms/forms';
import clientService from '../../services/client';
import addressTypeService from '../../services/addressType';
import addressTransformer from '../../transformers/address';
import stringFormatMixin from './../../mixins/stringFormat';
import countryService from './../../services/country';
import municipalityService from './../../services/municipality';

export default {
  data() {
    return {
      form: new Forms({}),
      client: {},
      loading: false,
      clientAddressNames: null,
      clientAddresses: [],
      addressFormErrors: {
        postal: null,
        fields: [],
      },
    };
  },

  props: {
    clientId: {
      type: [String, Number],
      required: true,
    },
    billId: {
      type: [String, Number],
      required: false,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters({
      currentBill: 'currentBill',
      addressTypes: 'addressTypes',
      countries: 'allCountries',
      municipalities: 'allMunicipalities',
    }),
  },

  watch: {
  },

  mounted() {
    this.loading = true;
    Promise.all([
      clientService.show(this.clientId),
      addressTypeService.all(),
      countryService.all(),
      municipalityService.all(),
    ]).then((data) => {
      this.loading = false;
      this.client = data[0];
      this.clientAddressNames = ['Postal'];
      this.setCurrentAddresses(this.client.addresses);
    });
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    setCurrentAddresses(addresses) {
      this.addressTypes.forEach((type) => {
        let address = addresses.find(a => type.id === a.address_type.id) || {};
        if (address) {
          address = addressTransformer.fetch(address);
        }
        this.clientAddresses.push(Object.assign({}, {
          id: type.id,
          addressType: type.id,
          name: type.name,
        }, address));
      });
    },

    save() {
      this.form.loading = true;
      const formData = new FormData();
      if (this.billId) {
        formData.append('bill_id', this.billId);
      }
      this.clearAddressErrors();
      this.clientAddresses.forEach((clientAddress) => {
        const data = addressTransformer.send(clientAddress);
        const formKey = `addresses[${clientAddress.addressType}]`;
        if (clientAddress.addressId) {
          formData.append(`${formKey}[id]`, clientAddress.addressId);
        }
        formData.append(`${formKey}[type]`, clientAddress.addressType);
        Object.keys(data).map((k) => {
          const key = `${formKey}[${k}]`;
          formData.append(key, data[k]);
          return null;
        });
      });

      clientService.updateAddress(this.client.id, formData)
        .then((client) => {
          this.close();
          this.$message({
            message: this.$t('static.clients.edit.success'),
            type: 'success',
          });
          this.onClose(client).then(() => {
            this.postalAddressError = false;
            this.form.loading = false;
            this.setAddressFieldErrors([]);
          }).catch(() => {});
        }).catch((errors) => {
          this.setAddressFieldErrors(errors);
          this.form.loading = false;
        });
    },

    clearAddressErrors() {
      this.addressTypes.forEach((t) => {
        this.addressFormErrors.fields[t.id] = [];
      });
    },
    setAddressFieldErrors(errors) {
      if ('addresses' in errors) {
        this.addressFormErrors.postal = true;
      } else {
        this.addressFormErrors.postal = false;
        this.clearAddressErrors();
      }
      Object.keys(errors).filter(key => key.indexOf('addresses.') !== -1).map((key) => {
        const [name, addressTypeId, field] = key.split('.');
        if (typeof errors[key][0] !== 'undefined') {
          if (typeof this.addressFormErrors.fields[addressTypeId] === 'undefined') {
            this.addressFormErrors.fields[addressTypeId] = [];
            this.addressFormErrors.fields[addressTypeId][field] = [];
          }
          const message = errors[key][0].replace(key, field);
          this.addressFormErrors.fields[addressTypeId][field] = [message];
        }
        return null;
      });
    },
    getAddressFieldErrors(addressTypeId) {
      if (addressTypeId in this.addressFormErrors.fields) {
        return addressTransformer.fetch(this.addressFormErrors.fields[addressTypeId]);
      }
      return null;
    },
    close() {
      this.toggle(false);
    },
  },

  components: {
    VForm: require('./../form/form.vue'),
    VClientAddress: require('./../../components/clientAddress/clientAddress.vue'),
  },
  mixins: [
    stringFormatMixin,
  ],
};



// WEBPACK FOOTER //
// ./src/app/components/clientAddressPopup/clientAddressPopup.js